<template>
    <div class="grid">
        <div class="col-12">
            <div class="col-12 sticky">
                <div id="custom_card" class="card">
                    <div class="grid justify-content-between">
                        <div class="col-12 md:col-6">
                            <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
                            >
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("asset_audit_entry") }}
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="container Application_container mt-4">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-12 md:col-3 mt-3" >
                            <span class="p-float-label">
                            <Dropdown
                                id="AssetCodeDropDown"
                                v-model="AssetCodeDropDownItem"
                                :options="asset_code_master"
                                optionLabel="name"
                                @change="getDesc()"
                                filter
                                
                            >
                            </Dropdown>
                            <label>{{ $t("asset_code") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3">
                            <span class="p-float-label">
                            <InputText
                                id="asset_discription"
                                type="text"
                                v-model="asset_discription"
                                disabled
                            />
                            <label for="name">{{ $t("asset_discription") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3">
                            <span class="p-float-label">
                            <Dropdown
                                id="status"
                                v-model="YearDropDownItem"
                                :options="year_master"
                                optionLabel="name"
                                filter
                                
                            >
                            </Dropdown>
                            <label>{{ $t("financial_year") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3" >
                            <span class="p-float-label">
                            <InputText
                                id="asset_discription"
                                type="text"
                                v-model="Department"
                                
                            />
                            <label for="name">{{ $t("department") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3">
                            <span class="p-float-label">
                            <InputText
                                id="asset_discription"
                                type="text"
                                v-model="AuditorName"
                                
                            />
                            <label for="name">{{ $t("auditor_name") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3">
                            <span class="p-float-label">
                             <Calendar
                                id="ticket_title"
                                v-model="AuditDate"
                                dateFormat="dd/mm/yy"
                            />
                            <label for="name">{{ $t("audit_date") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3" style="margin-top: 1%">
                            <div class="flex flex-wrap gap-3" style="margin-top: 3%">
                            <div class="flex align-items-center">
                                <label for="gender" class="mb-2">{{ $t("availability") }}</label>
                            </div>
                            <div class="flex align-items-center">
                                <RadioButton
                                v-on:change="change()"
                                v-model="Availability"
                                inputId="ingredient1"
                                name="Yes"
                                value="Yes"
                                ></RadioButton>
                                <label for="ingredient1" class="ml-2">{{ $t("yes") }}</label
                                >&nbsp;
                                <RadioButton
                                v-on:change="change()"
                                v-model="Availability"
                                inputId="ingredient2"
                                name="No"
                                value="No"
                                />
                                <label for="ingredient2" class="ml-2">{{ $t("no") }}</label>
                            </div>
                            <div class="flex align-items-center"></div>
                            </div>
                        </div>

                        
                        
                    </div>
                    <div class="p-fluid formgrid grid">
                            <div class="field col-12 md:col-3 mt-3" v-if="Availability=='Yes'">
                            <span class="p-float-label">
                            <InputText
                                id="asset_discription"
                                type="text"
                                v-model="Location"
                                
                            />
                            <label for="name">{{ $t("location") }}</label>
                            </span>
                        </div>

                        
                        <div class="field col-12 md:col-3 mt-3" v-if="Availability=='No'">
                            <span class="p-float-label">
                            <Textarea
                                id="asset_discription"
                                type="text"
                                v-model="NonAvailabilityReason"
                                
                            />
                            <label for="name">{{ $t("non_availability_reason") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-3 mt-3" v-if="Availability=='No'">
                            <span class="p-float-label">
                            <Textarea
                                id="asset_discription"
                                type="text"
                                v-model="NonAvailabilityRemark"
                                
                            />
                            <label for="name">{{ $t("non_availability_remark") }}</label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-2 mt-3">
                            <FileUpload
                            ref="fileUploader"
                            class="p-button-primary"
                            mode="basic"
                            name="model[]"
                            :auto="true"
                            :custom-upload="true"
                            :choose-label="$t('attachment')"
                            accept="application/pdf"
                            @uploader="handleFileUpload($event)"
                            />
                        </div>
                        <div class="field col-12 md:col-1 mt-3" v-if="url!=''">
                            <Button
                
                                icon="pi pi-file-pdf"
                                :title="$t('view_details')"
                                v-tooltip.bottom="$t('view')"
                                class="p-button-danger mr-2"
                                @click="viewattach()"
                                
                            />
                         
                        </div>
                        
                    </div>
                    <div style="text-align: center;">
                        <Button
                            :label="$t('save')"
                            @click="Submit"
                            icon="pi pi-check"
                            class="p-button-success"
                            />&nbsp;
                            <Button
                            :label="$t('reset')"
                            @click="reset"
                            icon="pi pi-refresh"
                            class="p-button-danger"
                            />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: "MahatakrarDepreciationHistoryAssetWise",
    data() {
        return {
            
            url:'',
            AssetCodeDropDownItem :null,
            asset_code_master:[],

            year_master: [],
            YearDropDownItem: null,

            asset_discription:'',
            Location:"",
            Department:"",
            Availability:'Yes',
            NonAvailabilityReason:"",
            NonAvailabilityRemark:"",
            AuditorName:"",
            AuditDate:"",
            file_data : {
                            filePath: '',
                            contentType: '',
                        },

        };
    },
    async mounted() {
        this.year_master = this.getPreviousTenFinancialYears();
        this.get_list();
    },
    methods: {
        viewattach(){
            window.open(this.url)
        },
        async date_time_prefix() 
        {
            // Get the current date and time
            const currentDateTime = new Date();
            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "_");
            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime
                .toTimeString()
                .split(" ")[0]
                .replace(/:/g, "_");
            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        async handleFileUpload(event) 
        {
            var fileUp = event.files[0];
            var file = fileUp;

                if (file.type !== "application/pdf") {
                   
                    this.$refs.fileUploader.clear();
                    this.$toast.add({
                    severity: "error",
                    summary: this.$t("error"),
                    detail: this.$t("Only PDF files are allowed."),
                    life: 3000,
                    });
                    return false;

                   
                }

            this.file = file;
            var prfeix = await this.date_time_prefix();
            var filename = prfeix + "_" + file.name;
            this.file_data = {
                filePath: filename,
                contentType: file.type,
            };
            var promise = apis.upload_to_AWS(this.file_data);
            promise.then((response) => {
                axios
                .put(response.data.data, file, {
                    headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": file.type,
                    },
                })
                .then((response) => {
                    this.url =
                    "https://eticket-docs.s3.ap-south-1.amazonaws.com/" + filename;
                });
            });
        },
        change(){
            if (this.Availability=='Yes') 
            {
                this.NonAvailabilityReason = "";
                this.NonAvailabilityRemark = "";
            } else 
            {
                this.Location = "";
            }
        },
        reset(){
            this.asset_discription = '';
            this.Location = "";
            this.Department = "";
            this.Availability = 'Yes';
            this.NonAvailabilityReason = "";
            this.NonAvailabilityRemark = "";
            this.AuditorName = "";
            this.AuditDate = "";
            this.YearDropDownItem= null;
            this.AssetCodeDropDownItem =null;
            this.url = "";
        },
        getDesc()
        {
            this.asset_discription = this.AssetCodeDropDownItem?.discription;
        },
        get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        asset_status: "",
        search: "",
        count: false,
        page_no: 1,
        limit: 1000,
        "asset_type":"",
        "asset_sub_type":"",
        "depreciation_method":""
      };
      
      var promise = apis.listAssets(data, this.id);
      promise.then((response) => {
        

        const temp = response.data.data;
        this.asset_code_master = temp.map(item => ({
        name: item.asset_code,
        value: item._id,
        discription:item.asset_discription
        }));

      });
      
    },
        getPreviousTenFinancialYears() 
        {
            const financialYears = [];
            const currentMonth = new Date().getMonth(); // 0-indexed (0 for Jan, 11 for Dec)
            const currentYear = new Date().getFullYear();
            let startYearOfCurrentFY;
            // Determine the starting year of the current financial year
            // If current month is Jan, Feb, or Mar, the FY started in April of the previous calendar year.
            // Otherwise (Apr-Dec), the FY started in April of the current calendar year.
            if (currentMonth >= 0 && currentMonth <= 2) { // January, February, March
                startYearOfCurrentFY = currentYear - 1;
            } else { // April to December
                startYearOfCurrentFY = currentYear;
            }
            for (let i = 0; i < 10; i++) {
                const startYear = startYearOfCurrentFY - i;
                const endYear = startYear + 1;
                financialYears.push({
                name: `${startYear}-${endYear}`,
                value: `${startYear}`
                });
            }
            return financialYears;
        },
        
        
        
        Submit() 
        {
            if (!this.AssetCodeDropDownItem) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("select_asset_code"),
                life: 3000,
                });
                return false;
            }
            if (!this.YearDropDownItem) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("select_financial_year"),
                life: 3000,
                });
                return false;
            }
            if (!this.Department) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_department"),
                life: 3000,
                });
                return false;
            }
            if (!this.AuditorName) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_auditorname"),
                life: 3000,
                });
                return false;
            }
            if (!this.AuditDate) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_auditdate"),
                life: 3000,
                });
                return false;
            }
            if (!this.Availability) 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("select_availability"),
                life: 3000,
                });
                return false;
            }
            if (this.Availability=='Yes' && this.Location=='') 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_location"),
                life: 3000,
                });
                return false;
            }
            if (this.Availability=='No' && this.NonAvailabilityReason=='') 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_nonavailabilityreason"),
                life: 3000,
                });
                return false;
            }
            if (this.Availability=='No' && this.NonAvailabilityRemark=='') 
            {
                this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("enter_nonavailabilityremark"),
                life: 3000,
                });
                return false;
            }


            var data = {
                
                asset_id:this.AssetCodeDropDownItem?.value,
                asset_code:this.AssetCodeDropDownItem?.name,
                asset_discription:this.AssetCodeDropDownItem?.discription,
                financial_year:this.YearDropDownItem?.value,
                department:this.Department,
                availability:this.Availability,
                Location:this.Location,
                NonAvailabilityReason:this.NonAvailabilityReason,
                NonAvailabilityRemark:this.NonAvailabilityRemark,
                AuditorName:this.AuditorName,
                AuditDate:this.AuditDate,
                "created_by": localStorage.getItem("id"),
                client_id: localStorage.getItem("client_id"),
                "lang": this.$i18n.locale,
                attachment : this.url
            };
            var promise = apis.createauditentry(data);
            promise.then((response) => {
                if (response.data.status == true) 
                {
                    this.$toast.add({
                        severity: "success",
                        summary: "success",
                        detail: response.data.message,
                        life: 3000,
                    });
                    this.reset();
                } 
                else 
                {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: response.data.message,
                        life: 3000,
                    });
                }
                    
            });
        },
    },
};
</script>
<style scoped>
</style>
